import React from 'react';
import { clsx } from 'clsx';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
  labelClassName?: string;
  containerClassName?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  icon,
  className,
  labelClassName,
  containerClassName,
  ...props
}) => {
  return (
    <div className={clsx("w-full", containerClassName)}>
      {label && (
        <label className={clsx("block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2", labelClassName)}>
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
            {icon}
          </div>
        )}
        <input
          className={clsx(
            'block w-full rounded-xl border-0 ring-1 ring-gray-200 bg-gray-50 py-3.5 shadow-sm transition-all duration-200',
            'focus:ring-2 focus:ring-blue-500 focus:bg-white',
            'hover:ring-gray-300 hover:bg-white',
            'placeholder:text-gray-400 placeholder:italic text-gray-900 font-medium',
            'disabled:bg-gray-100 disabled:cursor-not-allowed',
            icon ? 'pl-10' : 'px-4', // Add padding-left 10 if icon, else px-4
            error && 'ring-red-500 focus:ring-red-500 bg-red-50/30',
            className
          )}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-red-600 font-medium flex items-center gap-1">
          <span className="w-1 h-1 rounded-full bg-red-600 inline-block" />
          {error}
        </p>
      )}
      {helperText && !error && (
        <p className="mt-1.5 text-xs text-gray-500">{helperText}</p>
      )}
    </div>
  );
};





